<template>
  <th :class="thClass" :aria-sort="ariaSort">
    <button
      type="button"
      class="group flex items-center gap-1 text-left uppercase tracking-wide
             font-semibold text-[11px] text-gray-600 hover:text-gray-900"
      @click="$emit('sort', sortKey)"
    >
      <span :class="active ? 'text-gray-900' : ''"><slot /></span>
      <span
        class="text-[9px] leading-none"
        :class="active ? 'text-gray-900' : 'text-transparent group-hover:text-gray-300'"
      >{{ active && direction === 'desc' ? '▼' : '▲' }}</span>
    </button>
  </th>
</template>

<script>
export default {
  name: 'LatencySortHeader',
  props: {
    sortKey: { type: String, required: true },
    activeKey: { type: String, required: true },
    direction: { type: String, required: true },
    thClass: { type: String, required: true },
  },
  emits: ['sort'],
  computed: {
    active() {
      return this.sortKey === this.activeKey;
    },
    ariaSort() {
      if (!this.active) return 'none';
      return this.direction === 'desc' ? 'descending' : 'ascending';
    },
  },
};
</script>
